var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"snackbar-wrapper ml-0 mr-0 pl-0 pr-0"})
}
var staticRenderFns = []

export { render, staticRenderFns }